import useEntranceAnimation from '../../client/hooks/useEntranceAnimation';
import AnimatedBar from './AnimatedBar';

type CategoryRow = {
  name: string;
  count: number;
  avgSentiment: number;
};

type CategoryChartProps = {
  data: CategoryRow[];
};

const COLORS = [
  '#ec4899', // pink (brand)
  '#f97316', // orange
  '#eab308', // yellow
  '#22c55e', // green
  '#06b6d4', // cyan
  '#8b5cf6', // violet
  '#f43f5e', // rose
  '#14b8a6', // teal
];

const MAX_CATEGORIES = 8;

export default function CategoryChart({ data }: CategoryChartProps) {
  const animated = useEntranceAnimation();
  const categories = data.slice(0, MAX_CATEGORIES);
  const maxCount = categories.length > 0 ? categories[0].count : 1;

  if (categories.length === 0) {
    return (
      <div className="flex h-48 items-center justify-center text-sm text-neutral-400 dark:text-neutral-500">
        No category data for this period
      </div>
    );
  }

  return (
    <div className="space-y-2.5" role="list" aria-label="Category breakdown">
      {categories.map((cat, i) => (
        <AnimatedBar
          key={cat.name}
          label={cat.name}
          value={String(cat.count)}
          percent={(cat.count / maxCount) * 100}
          color={COLORS[i % COLORS.length]}
          animated={animated}
          index={i}
        />
      ))}
    </div>
  );
}
